import { render, staticRenderFns } from "./chatGroupCreateDialog.vue?vue&type=template&id=72800ea2&scoped=true"
import script from "./chatGroupCreateDialog.vue?vue&type=script&lang=js"
export * from "./chatGroupCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./chatGroupCreateDialog.vue?vue&type=style&index=0&id=72800ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72800ea2",
  null
  
)

export default component.exports